import { BadgeVariant } from 'components/common/Badge'
import {
  MedicationDrugInteraction,
  MedicationDrugInteractionsData,
  MedicationInteractionSeverityLevel,
} from 'types/Medications'
import orderBy from 'lodash/orderBy'

const config: Record<MedicationInteractionSeverityLevel, { label: string; badgeVariant: BadgeVariant; order: number }> =
  {
    MajorInteraction: { label: 'Severe', badgeVariant: 'error-solid', order: 1 },
    ModerateInteraction: { label: 'Moderate', badgeVariant: 'warning-strong-solid', order: 2 },
    MinorInteraction: { label: 'Minor', badgeVariant: 'warning-solid', order: 3 },
  } as const

export const getMedicationInteractionSeverityLevelUiConfig = (severityLevel: MedicationInteractionSeverityLevel) =>
  config[severityLevel]

export const getOrderedDrugInteractions = (drugInteractions: MedicationDrugInteractionsData[]) =>
  orderBy(
    drugInteractions || [],
    [({ severityLevel }) => getMedicationInteractionSeverityLevelUiConfig(severityLevel)?.order],
    ['asc'],
  )

export const getJoinedInteractionsDrugs = (drugs: MedicationDrugInteraction[]) =>
  drugs
    ?.map(({ drugName }) => drugName)
    .filter(Boolean)
    .join(' - ') || ''
